export var SET_TELEMETRY_LABELS = 'SET_TELEMETRY_LABELS';
export var SET_TELEMETRY_CUSTOM = 'SET_TELEMETRY_CUSTOM';
export var SET_TELEMETRY_USER = 'SET_TELEMETRY_USER';
